var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Menu'),_c('PwdChange',{attrs:{"emailx":_vm.$usrStore.email,"mNbrx":_vm.$usrStore.mNbr,"aKey":Math.random(),"adm":_vm.$hasRole(['adm','sys'])}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }